import React from "react";
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import 'katex/dist/katex.min.css';
import { BlockMath, InlineMath } from 'react-katex';

function Calculationcomponent({ results, inputData }) {
  if (!results || Object.keys(results).length === 0) {
    return <div>No results to display yet.</div>;
  }

  const activeResults = results.activeResults
  const earthResults = results.Earth_Result
  const RCDinstalled = inputData.rcdChecked
  const loadcurrent = inputData.loadCurrent
  const deratingfactor = activeResults?.Derating?.[activeResults.Derating.length - 1]?.[1]?.[0];
  const maximum_operating_temp = results?.activeResults?.voltageDrop?.max_operating_temp
  const ambient_operating_temp = results?.activeResults?.voltageDrop?.ambient_operating_temp
  const operating_temperature = results?.activeResults?.voltageDrop?.operating_temperature
  const selectedPhase = inputData?.phase
  const lengthofrun = inputData?.lengthOfCable
  const PF = inputData?.powerFactor
  const voltage = inputData?.supplyVoltage
  const activetriptime = inputData?.activetriptime
  const earthtripcurrent = inputData?.earthtripcurrent
  // Extracting values
  const Active_cable_size = activeResults?.selectedCableSize;
  const Active_cable_mode = inputData?.activeCableSizingMode;
  const Circuit_capacity_derated = activeResults?.currentCarryingCapacity?.circuitRatingDerated;
  const Circuit_capacity = activeResults?.currentCarryingCapacity?.circuitRating;
  const spare_capacity = Math.round(activeResults?.currentCarryingCapacity?.spareCapacity * 100) / 100;
  const number_of_active_circuits = activeResults?.number_of_circuits;
  const current_carrying_cap_ok = activeResults?.currentCarryingCapacity?.ok;
  const current_carrying_cap_ref = activeResults?.currentCarryingCapacity?.current_capacity_ref;

  const Voltage_drop = Math.round(activeResults?.voltageDrop?.voltageDropCable * 100) / 100;
  const voltage_drop_percent = Math.round(activeResults?.voltageDrop?.voltageDropPercent * 100) / 100;
  const max_length_cable = Math.round(activeResults?.voltageDrop?.maxLengthOfCable * 100) / 100;
  const resistance_active = activeResults.voltageDrop?.resistancePerKm;
  const reactance_active = activeResults.voltageDrop?.reactancePerKm;
  const operating_temp_calculation = Math.round(activeResults?.voltageDrop?.operatingTempCalculated * 100) / 100;
  const voltage_drop_cap_ok = activeResults?.voltageDrop?.ok;
  const resistance_active_ref = activeResults.voltageDrop?.resistance_per_km_ref;
  const reactance_active_ref = activeResults.voltageDrop?.reactance_per_km_ref;

  const short_circuit_soure = activeResults?.shortCircuitCapacity?.faultLevelSupply;
  const short_circuit_load = Math.round(activeResults?.shortCircuitCapacity?.faultLevelLoad * 100) / 100;
  const K_value = activeResults?.shortCircuitCapacity?.KValue;
  const source_impedance = activeResults?.shortCircuitCapacity?.sourceImpedance;
  const total_impedance = activeResults?.shortCircuitCapacity?.totalImpedance;
  const short_circuit_capacity = Math.round(activeResults?.shortCircuitCapacity?.ICalculation * 100) / 100;
  const short_circuit_cap_ok = activeResults?.shortCircuitCapacity?.ok;
  const cablecrosssec = activeResults?.shortCircuitCapacity?.cablecrosssec;
  const K_value_ref = activeResults?.shortCircuitCapacity?.KValue_ref;
  const derating = activeResults?.Derating
  const shortcircuitfinaltemp = activeResults?.shortCircuitCapacity?.final_operating_temperature
  const shortcircuitinitialtemp = activeResults?.shortCircuitCapacity?.initial_operating_temperature

  const Earth_cable_size = earthResults?.Earth_cable_size;
  const max_operating_temp = earthResults?.max_operating_temp;

  const number_of_earth_circuit = earthResults?.number_of_earth_circuits;
  const earthCableSizingMode = inputData?.earthCableSizingMode;
  const earthRef = earthResults?.ref
  const Phase_voltage = Math.round(earthResults?.Phase_voltage* 100) / 100;
  const EFLcheck = earthResults?.Loop_impedance_check
  const ImpedanceEarth = Math.round(earthResults?.Impednace_earth* 10000) / 10000;
  const ImpedanceActive = Math.round(earthResults?.Impedance_active * 10000) / 10000;
  const Zint = Math.round(earthResults?.Z_int* 10000) / 10000;
  const Zext = Math.round(earthResults?.Z_ext* 10000) / 10000;
  const EFL = Math.round(earthResults?.Loop_impedance* 10000) / 10000;
  const earthfaultlevel =  inputData?.earthfaultlevel;
  const earthfaultlevelcheck =  earthResults?.short_circuit_ok;
  const earthshortcircuitcap = Math.round(earthResults?.short_circuit_cap* 100) / 100;
  const kvalue = earthResults?.K;
  const K_value_refearth = earthResults?.K_value_ref;
  const Requiredloopimpidance = Math.round(earthResults?.Requiredloopimpidance* 100) / 100;
  const earth_Fault_level = Math.round(earthResults?.earth_Fault_level* 100) / 100;
  const initial_operating_temperature = Math.round(earthResults?.initial_operating_temperature* 100) / 100;


  
    return (
  <div className="App">
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems=""
          style={{ minHeight: "10vh",
              padding: "1.5rem",
           }}
        >
            <Grid item xs={12} sm={12} md={12}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >

                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
                          <Typography variant="h3"          
                           sx={{
                            fontSize: { xs: "16px", md: "25px" }, // Adjust font size for subtitle
                            fontWeight: "700",
                            fontFamily: "'Hubballi', sans-serif",
                            letterSpacing: "1px",
                        }}> 
                            ACTIVE CABLE SIZE CALCULATION
                          </Typography>
                          
                        </Stack>

                          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        
                        
                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                letterSpacing: "1px",
                              }}
                        >
                          STEP ONE (CURRENT CARRYING CAPACITY CHECK)<br />
                        </Typography>
                          </Stack>

                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
                            <BlockMath math={`I_{load} = ${loadcurrent}\\,A`} /> 
<BlockMath math={`Cable\\,Derated\\,Capacity = Cable\\,Capacity \\,(${current_carrying_cap_ref}) \\times Derating Factor =  ${Circuit_capacity} \\times ${deratingfactor} = ${Circuit_capacity_derated}\\,A`} />
<BlockMath math={`Spare\\, Capacity\\, Available = ${Circuit_capacity_derated} - ${loadcurrent} = ${spare_capacity}\\,A`} />
                          
                          
                          </Typography>
                          
                                                    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        
                        
                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                letterSpacing: "1px",
                                overflowX: 'auto',
                                paddingTop: "15px"
                              }}
                        >
                          STEP TWO (VOLTAGE DROP CALCULATION)<br />
                        </Typography>
                          </Stack>

                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
<BlockMath math={`Cable\\ Operating\\ Temperature = ({\\frac{I_{0}}{I_{R}}})^2 \\times (\\theta_{R} - \\theta_{A}) + \\theta_{A} = ({\\frac{${loadcurrent}}{${Circuit_capacity_derated}}})^2 \\times (${maximum_operating_temp} - ${ambient_operating_temp}) + ${ambient_operating_temp} = ${operating_temp_calculation} ^\\circ\\mathrm{C}`} />
<BlockMath math={`Cable \\ Resistance\\ at\\ (${operating_temperature}^\\circ\\mathrm{C}) =  ${resistance_active} \\ ohms/km \\ (${resistance_active_ref})`} />
<BlockMath math={`Cable \\ Reactance\\  =  ${reactance_active} \\ ohms/km \\ (${reactance_active_ref})`} />     
{selectedPhase === "1 - Phase AC" && (
    <Box>
  <BlockMath math={`1-Phase Voltage Drop = \\frac{IL \\left[ 2(R_{c} \\cos\\theta + X_{c} \\sin\\theta) \\right]}{1000} = \\frac{${loadcurrent} \\times ${lengthofrun} \\left[ 2((${resistance_active} \\times ${PF}) + (${reactance_active} \\times \\sqrt{1 - \\mathrm${PF}^2}))  \\right]}{1000} = ${Voltage_drop}\\ V`} />
  <BlockMath math={`Voltage\\ Drop \\ Percent = \\frac{Voltage\\ Drop}{Supply\\ Voltage} = \\frac{${Voltage_drop}}{${voltage}} = ${voltage_drop_percent} \\ \\%`} />
</Box>
)}
{selectedPhase === "3 - Phase AC" && (
     <Box>
  <BlockMath math={`Voltage\\ Drop\\ Per\\ Phase = \\frac{IL \\left[ \\sqrt{3}(R_{c} \\cos\\theta + X_{c} \\sin\\theta) \\right]}{1000} = \\frac{${loadcurrent} \\times ${lengthofrun} \\left[ \\sqrt{3}((${resistance_active} \\times ${PF}) + (${reactance_active} \\times \\sqrt{1 - \\mathrm${PF}^2}))  \\right]}{1000} = ${Voltage_drop}\\ V`} />
  <BlockMath math={`Voltage\\ Drop \\ Percent = \\frac{Voltage\\ Drop}{Phase\\ Voltage} = \\frac{${Voltage_drop}}{${voltage}/\\sqrt{3}} = ${voltage_drop_percent} \\ \\%`} />
</Box>
)}

{selectedPhase === "DC" && (
    <Box>
  <BlockMath math={`Voltage\\ Drop = \\frac{ILR_{c}}{1000} = \\frac{${loadcurrent}\\times${lengthofrun} \\times${resistance_active}}{1000} = ${Voltage_drop}\\ V`} />
  <BlockMath math={`Voltage\\ Drop \\ Percent = \\frac{Voltage\\ Drop}{Supply\\ Voltage} = \\frac{${Voltage_drop}}{${voltage}} = ${voltage_drop_percent} \\ \\%`} />
</Box>
)}     


                          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        
                        
                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                overflowX: 'auto',
                                letterSpacing: "1px",
                              }}
                        >
                          STEP THREE (SHORT CIRCUIT TEMPERATURE RISE)<br />
                        </Typography>
                          </Stack>

                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
<BlockMath math={`Maximum\\ Permissible\\ Shortcircuit\\ Temperature =${shortcircuitfinaltemp}^\\circ\\mathrm{C}`} /> 
<BlockMath math={`Initial\\ Operating \\ Temperature =${shortcircuitinitialtemp}^\\circ\\mathrm{C}`} /> 
<BlockMath math={`K \\ Value \\ (${K_value_ref}) =${K_value}`} /> 
<BlockMath math={`Short \\ Circuit\\ Duration = ${activetriptime} \\ s`} />                     
<BlockMath math={`Short \\ Circuit\\ Capacity = \\sqrt{\\frac{K^2 \\times S^2}{t}} = \\sqrt{\\frac{${K_value}^2 \\times ${Active_cable_size}^2}{${activetriptime}}} = ${short_circuit_soure} A`} />                            
                          </Typography>
                          </Typography>

                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
                          <Typography variant="h3"          
                           sx={{
                            fontSize: { xs: "16px", md: "25px" }, // Adjust font size for subtitle
                            fontWeight: "700",
                            fontFamily: "'Hubballi', sans-serif",
                            letterSpacing: "1px",
                            paddingTop: "50px"
                        }}> 
                            EARTH CABLE SIZE CALCULATION
                          </Typography>
                          
                        </Stack>

{earthCableSizingMode === "Automatic" && (
    <Box>
                                   <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
  <BlockMath math={`Earth \\ Cable \\ Size \\ Based \\ on \\ AS3000 \\ Table \\  5.1`} />
   <BlockMath math={`Total \\ Active \\ Cross \\ Sectional \\ Area = Number \\ of \\ Cicuits \\times Cable \\ Crossectional \\ Area = ${number_of_active_circuits} \\times ${Active_cable_size} \\ mm^2 = ${cablecrosssec} \\ mm^2`} />
  <BlockMath math={`Earth \\ Cable \\ Size \\ Based \\ on \\ Table \\ 5.1 = ${number_of_earth_circuit} \\times ${Earth_cable_size} mm^2`} />
  </Typography>
</Box>
)}                            


{earthCableSizingMode !== "Automatic" && (
    <Box>
           <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        
                        
                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                overflowX: 'auto',
                                letterSpacing: "1px",
                              }}
                        >
                          EARTH FAULT LOOP IMPEDANCE CHECK<br />
                        </Typography>
                          </Stack>
                                <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
<BlockMath math={`Active \\ Cable \\ Impedance \\ At \\ ${max_operating_temp}^\\circ\\mathrm{C} = ${ImpedanceActive} \\ ohms`} />
<BlockMath math={`Earth \\ Cable \\ Impedance \\ At \\ ${max_operating_temp}^\\circ\\mathrm{C} = ${ImpedanceEarth} \\ ohms`} />
<BlockMath math={`Z \\ Internal \\ = \\ Active \\ Impedance \\ + \\ Earth \\ Impednace = ${Zint} \\ ohms`} />
<BlockMath math={`Z \\ External \\ = \\frac{Phase \\ - \\ Gorund \\ Voltage}{Earth \\ Fault \\ Level} = \\frac{${Phase_voltage} V}{${earthfaultlevel} \\ kA} = ${Zext} \\ ohms`} />
<BlockMath math={`Earth \\ Fault \\ Loop \\ Impedance = Z \\ Internal + Z \\ External = ${EFL} \\ ohms`} />

<BlockMath math={`Earth \\ Fault \\ Current \\ For \\ A \\ Fault \\ Downstream = \\frac{Phase \\ - \\ Gorund \\ Voltage}{Earth \\ Fault \\ Loop \\ Impedance} = \\frac{${Phase_voltage}}{${EFL}} = ${earth_Fault_level} \\ A`} />

<BlockMath math={`Protection \\ Set \\ At = ${earthtripcurrent} A`} />
{!RCDinstalled && (
<BlockMath math={`RCD \\ Installed  = No`} />)}
{RCDinstalled && (
<BlockMath math={`RCD \\ Installed  = Yes`} />)}

                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                overflowX: 'auto',
                                letterSpacing: "1px",
                              }}
                        >
                          EARTH SHORT CIRCUIT TEMPERATURE RISE<br />
                        </Typography>
</Typography>

                                <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
<BlockMath math={`Maximum\\ Permissible\\ Shortcircuit\\ Temperature =${shortcircuitfinaltemp}^\\circ\\mathrm{C}`} /> 
<BlockMath math={`Initial\\ Operating \\ Temperature =${initial_operating_temperature}^\\circ\\mathrm{C}`} /> 
<BlockMath math={`K \\ Value \\ (${K_value_refearth}) =${kvalue}`} /> 
<BlockMath math={`Short \\ Circuit\\ Duration = ${activetriptime} \\ s`} />                     
<BlockMath math={`Short \\ Circuit\\ Capacity = \\sqrt{\\frac{K^2 \\times S^2}{t}} = \\sqrt{\\frac{${kvalue}^2 \\times ${Earth_cable_size}^2}{${activetriptime}}} = ${earthshortcircuitcap} A`} />                            
<BlockMath math={`Earth \\ Fault \\ Current \\ For \\ A \\ Fault \\ Downstream = \\frac{Phase \\ - \\ Gorund \\ Voltage}{Earth \\ Fault \\ Loop \\ Impedance} = \\frac{${Phase_voltage}}{${EFL}} = ${earth_Fault_level} \\ A`} />
  
                          </Typography>



</Typography>


</Box>
)}       

          </Paper>
          </Grid>


        </Grid>
        </div>
      );
}

export default Calculationcomponent;
